import { apiBaseUrl, spevalApi } from 'yxt-biz-pc/packages/api';

const apiTalent = 'sptalentsd';

spevalApi.defaults.headers['x-yxt-product'] = 'sp';

// 报告库 项目维度模型模板下载
export const downLoadReportsProjectTemplate = (params) => {
  return spevalApi.post('/mgr/report/projectTemplate',
    params
  );
};

// 报告库项目维度 导入模型
export const reportsProjectPeopleImprot = (params, body) => {
  return spevalApi.post('/mgr/evaluations/import/third/party', body, { params });
};

// 批量查询模型ids
export const getModelNameByIds = (ids) => {
  return apiBaseUrl.post(`${apiTalent}/mgr/model/studyconfig/skillmodel`, {
    skillModelIds: ids
  });
};

